import { createFeatureActionNamer } from '../../redux/action-name';

const getActionName = createFeatureActionNamer('loadingScreen');

export const HIDE_LOADING = getActionName('HIDE_LOADING');
export const SHOW_LOADING = getActionName('SHOW_LOADING');
